import MyPreferencesForm from "../../components/CommunicationPreferences/MyPreferencesForm";

function MyPreferencesPage(): JSX.Element {
  return <MyPreferencesForm />;
}

export default MyPreferencesPage;
